export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./logout.vue?vue&type=template&id=4a024d5e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/authen/logout.vue?vue&type=template&id=4a024d5e&scoped=true&
// module id = 736
// module chunks = 5